/**
 * AI:
 * Status: "in progress"
 * Type: Component
 * SubType: WizardStep
 * Reason: Step 3 of POC wizard - success/done screen
 */
import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {LgPocWizardStateService} from '../../../../service/domain/lg-poc-wizard-state/lg-poc-wizard-state.service';

@Component({
    selector: 'lg-poc-wizard-step-done',
    templateUrl: './lg-poc-wizard-step-done.component.html',
    styleUrls: ['./lg-poc-wizard-step-done.component.scss'],
    standalone: false
})
export class LgPocWizardStepDoneComponent implements OnInit {

    @Output() onNavigate = new EventEmitter<void>();

    typeName: string = '';
    typeId: number;
    logicCount: number = 0;

    constructor(private wizardState: LgPocWizardStateService) {
    }

    ngOnInit(): void {
        const state = this.wizardState.state;
        this.typeName = state.createdTypeName || '';
        this.typeId = state.createdTypeId;
        this.logicCount = state.selectedLogics?.length || 0;

        this.wizardState.completeStep3();
    }

    onGoToType(): void {
        this.onNavigate.emit();
    }
}
